import axios from 'axios';

export default {
  request: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    const { param, cb } = payload;
    const url = `/engine/uuid/${param}`;
    axios({
      url: url,
      method: "GET",
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        if (typeof cb === "function") {
          cb(response.data);
        }
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  }
};
